(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pumiii-layered-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pumiii-layered-hero')) {
    customElements.define('pumiii-layered-hero', class extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('.pumiii-layered-hero__stage');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
        if (!this.stage || this.dataset.motionEnabled !== 'true') return;
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerLeave = this.onPointerLeave.bind(this);
        this.stage.addEventListener('pointermove', this.onPointerMove);
        this.stage.addEventListener('pointerleave', this.onPointerLeave);
      }

      disconnectedCallback() {
        if (!this.stage) return;
        this.stage.removeEventListener('pointermove', this.onPointerMove);
        this.stage.removeEventListener('pointerleave', this.onPointerLeave);
      }

      onPointerMove(event) {
        if (this.reducedMotion.matches || !this.finePointer.matches) return;
        const bounds = this.stage.getBoundingClientRect();
        const x = (event.clientX - bounds.left) / bounds.width - 0.5;
        const y = (event.clientY - bounds.top) / bounds.height - 0.5;
        const strength = Number.parseFloat(getComputedStyle(this).getPropertyValue('--pumiii-motion-strength')) || 16;
        this.style.setProperty('--pumiii-pets-x', `${x * strength}px`);
        this.style.setProperty('--pumiii-pets-y', `${y * strength * 0.55 - 8}px`);
        this.style.setProperty('--pumiii-word-x', `${x * strength * -0.55}px`);
        this.style.setProperty('--pumiii-word-y', `${y * strength * -0.25}px`);
      }

      onPointerLeave() {
        this.style.setProperty('--pumiii-pets-x', '0px');
        this.style.setProperty('--pumiii-pets-y', '0px');
        this.style.setProperty('--pumiii-word-x', '0px');
        this.style.setProperty('--pumiii-word-y', '0px');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
